<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <edit-betgame-form>

      </edit-betgame-form>
    </div>
  </div>
</template>
<script>
  import EditBetgameForm from './BGEditSettingsForm.vue'

  export default {
    components: {
      EditBetgameForm
    },
    created () {
      this.$log.debug('BGBetgame.created ' + this.$route.params.id)
    },
    beforeCreate () {
      this.$log.debug('BGBetgame.beforeCreate ' + this.$route.params.id)
    },
    mounted () {
      this.$log.debug('BGBetgame.mounted ' + this.$route.params.id)
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGBetgameSettings.vue